import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class RefreshUserTasksMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('RefreshUserTasksMessage', RefreshUserTasksMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');